// Programmatically Lighten or Darken a hex color (or rgb, and blend colors)

import { browser } from "$app/environment";

// https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
export function RGB_Linear_Shade(p: number, color: string) {
  let P: any,
    i = parseInt,
    t,
    r = Math.round,
    [a, b, c, d] = color.split(",");
  P = p < 0;
  t = P ? 0 : 255 * p;
  P = P ? 1 + p : 1 - p;
  return (
    "rgb" +
    (d ? "a(" : "(") +
    r(i(a[3] == "a" ? a.slice(5) : a.slice(4)) * P + t) +
    "," +
    r(i(b) * P + t) +
    "," +
    r(i(c) * P + t) +
    (d ? "," + d : ")")
  );
}

export function RGB_Log_Shade(p: number, color: string) {
  let P: any,
    t,
    i = parseInt,
    r = Math.round,
    [a, b, c, d] = color.split(",");
  P = p < 0;
  t = P ? 0 : p * 255 ** 2;
  P = P ? 1 + p : 1 - p;
  return (
    "rgb" +
    (d ? "a(" : "(") +
    r((P * i(a[3] == "a" ? a.slice(5) : a.slice(4)) ** 2 + t) ** 0.5) +
    "," +
    r((P * i(b) ** 2 + t) ** 0.5) +
    "," +
    r((P * i(c) ** 2 + t) ** 0.5) +
    (d ? "," + d : ")")
  );
}

export type ThemeColor =
  | "grey"
  | "gray"
  | "blue"
  | "green"
  | "yellow"
  | "light-gray"
  | "light-green"
  | "none";

export function isThemeLight(color: ThemeColor) {
  return color === "green" || color === "blue";
}

export type ThemeBackgroundColor = "sand" | "none";

export type PageDesignVariant =
  | "hero-footer"
  | "hero-footer-full-bleed"
  | "page";

export function parseUrl(url: any) {
  if (!url) return null;
  if (typeof url === "string") return url;
  if (url.linktype === "story") {
    return "/" + url.cached_url;
  }
  return url.cached_url;
}

export function stringSub(str: string, data: Record<string, unknown>): string {
  for (const key in data) {
    str = str.replace(new RegExp(`{${key}}`, "g"), `${data[key]}`);
  }
  return str;
}

export type QueryParams = Record<string, string | string[]>;

export function decodeBase64(input: string): string {
  if (browser) {
    return window.atob(input);
  }
  return Buffer.from(input, "base64").toString();
}

// Function to decode HTML entities in a string
export function decodeHTML(htmlString = "") {
  if (!htmlString.includes("&lt;")) {
    return htmlString;
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = htmlString;
    return textarea.value;
  } catch (error) {
    return htmlString;
  }
}
